export function pickFirstDefined<T>(
  source: Record<string, unknown>,
  keys: string[],
  fallback: T,
): T {
  for (const key of keys) {
    const value = source[key];
    if (value !== undefined && value !== null) {
      return value as T;
    }
  }
  return fallback;
}
